import { gql } from '@apollo/client';

export const ALL_SP_PROGRAMMES = gql`
  query AllSPProgrammes {
    programmes: allSPProgrammes {
      id
      name
    }
  }
`;
